import { PaymentTransactionDto } from './payment-transaction-dto';

export class PaymentTransactionCreditCardDto extends PaymentTransactionDto {
  constructor(public last4: string, paymentDate: Date, paymentMethodId: number) {
    super(paymentDate, paymentMethodId);
  }
}
